export enum OIBServiceCheckStatus {
  Unknown = 0,
  AlreadyChecked = 1,
  UpToDate = 2,
  IncompleteData = 3,
  HasChanges = 4,
  CreatedFromOIB = 5,
  Unreachable = 6
}